import { MenuHero } from "./menu-hero"
import { Customers } from "./customers"
import { Team } from "./team"
import { Solutions } from "./solutions"
import { CaseStudies } from "./case-studies"
import { OurOffices } from "./our-offices"
import { Footer } from "./footer"
import { TextCta } from "./text-cta"
import { Fullstack } from "./fullstack"
import { DevFriendly } from "./dev-friendly"
import { ContactUsForm } from "./contact-us-form"
import { Stats } from "./stats"
import { Gallery } from "@/contents/new-blocks/gallery"
import { CaseStudyContent } from "@/contents/new-blocks/case-study-content"
import { RichTextBlock } from "@/contents/new-blocks/rich-text-block"
import { FunnelCompany } from "@/contents/new-blocks/funnel-company"
import { FunnelDev } from "@/contents/new-blocks/funnel-dev"
import { Videos } from "@/contents/new-blocks/videos"
import { Article } from "@/contents/new-blocks/article"
import { ArticlesGrid } from "@/contents/new-blocks/articles-grid"
import { TwoColumnRichText } from "@/contents/new-blocks/two-column-richtext"

export const newBlocks = {
  article: Article,
  "articles-grid": ArticlesGrid,
  caseStudies: CaseStudies,
  caseStudyContent: CaseStudyContent,
  contactUsForm: ContactUsForm,
  customers: Customers,
  devFriendly: DevFriendly,
  "menu-hero": MenuHero,
  footer: Footer,
  fullstack: Fullstack,
  "funnel-company": FunnelCompany,
  "funnel-dev": FunnelDev,
  gallery: Gallery,
  ourOffices: OurOffices,
  richTextBlock: RichTextBlock,
  solutions: Solutions,
  stats: Stats,
  team: Team,
  textCta: TextCta,
  twoColumnRichText: TwoColumnRichText,
  videos: Videos,
}
